import {
  IngestionLabel,
  ingestionLabel,
  IngestionStatus,
} from "@/shared/domain/files";
import {
  type PendingIngestionFile,
  type SessionIngestionStatus,
  type SessionIngestionSummary,
  skippedFileCount,
} from "@/shared/domain/sessions";

export const PENDING_FILE_INGESTION_STATUS: Record<
  PendingIngestionFile["ingestion_status"],
  IngestionStatus
> = {
  not_ingested: IngestionStatus.NotIngested,
  partly_ingested: IngestionStatus.PartlyIngested,
  ingested: IngestionStatus.Ingested,
};

/** Whether the pending file is labelled "Ingestion failed". */
export function ingestionRunFailed(file: PendingIngestionFile): boolean {
  return (
    ingestionLabel(
      {
        ingestion_status: PENDING_FILE_INGESTION_STATUS[file.ingestion_status],
        ingestable: true,
      },
      { latestRun: file.last_run },
    ) === IngestionLabel.IngestionFailed
  );
}

/** The status reduced to the summary the sessions list reads for the same session. */
export function ingestionSummary(
  status: SessionIngestionStatus,
): SessionIngestionSummary {
  return {
    session_id: status.session_id,
    state: status.state,
    ingested_file_count: status.ingested_file_count,
    pending_file_count: status.pending_file_count,
    not_ingestable_file_count: status.not_ingestable_file_count,
    skipped_file_count: skippedFileCount(status),
    // Counted from the listed files when the server doesn't send it.
    failed_file_count:
      status.failed_file_count ??
      status.pending_files.filter(ingestionRunFailed).length,
  };
}
